<a routerLink="/" class="link">
  <img class="logo" src="../../../assets/images/logo-listo.png" alt="listo">
</a>
<div *ngIf="!authenticated">
  <div i18n>How can we help you?</div>
  <div><listo-phone-link class="link"></listo-phone-link></div>
</div>
<listo-agent-session-button *ngIf="authenticated"></listo-agent-session-button>

